import { getBrowserTimezone } from '@mi-front/core';

/** Normalizes an IANA timezone id for equality checks. */
function normalizeTimeZoneId(timeZone: string): string {
  return timeZone.trim().toLowerCase();
}

/**
 * Returns a locale-aware timezone label for an IANA zone (short name from Intl), or `null` when the
 * zone is missing or matches the browser timezone (no extra hint needed).
 * Falls back to the raw zone id when Intl rejects the zone.
 */
export function formatTimezoneDisplayName(
  timeZone: string | null | undefined,
  locale: string,
): string | null {
  const browserTz = getBrowserTimezone();
  const tz = timeZone?.trim();

  if (!tz || normalizeTimeZoneId(tz) === normalizeTimeZoneId(browserTz)) {
    return null;
  }

  try {
    const parts = new Intl.DateTimeFormat(locale, {
      timeZone: tz,
      timeZoneName: 'shortOffset',
    }).formatToParts(new Date());

    return parts.find((p) => p.type === 'timeZoneName')?.value ?? tz;
  } catch {
    return tz;
  }
}
